import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router';

import { PageLayout } from '~components/page/PageLayout';
import useLabels from '~hooks/useLabels';
import { postDownloadRequestWorkflowAction } from '~modules/media-library/controller/api/downloadRequest';

export default function DownloadRequestPage() {
  const { hlDownloadRequest } = useLabels(['hlDownloadRequest']);

  // derived values
  const { action, token } = useParams();

  let message = 'loading';

  const useTransition = (action: string, token: string) => {
    return useMutation({
      mutationFn: async () => await postDownloadRequestWorkflowAction(action, token),
    });
  };
  const { mutate, data, error } = useTransition(action, token);

  useEffect(() => {
    mutate();
  }, [action, mutate, token]);

  if (data) message = String(data);
  if (error) message = String((error as any).error);

  return (
    <PageLayout title={hlDownloadRequest} className="page--web2print">
      <div className="c-view__header u-margin-vertical-md u-padding-horizontal-xxl">
        <div className="o-grid o-grid--unpad o-grid--bottom">
          <div className="o-grid__cell o-grid__cell--width-10 w2p-header">
            <h2>{hlDownloadRequest}</h2>
            <p>{message}</p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
